module.exports = __webpack_public_path__ + "media/images/map_icons/Other-45fa0cac11e89457fae1fdc32d368e2c.svg";